export const subtitles = {
    "1": {
        "startTime": 33.27,
        "endTime": 40.45,
        "transcript": "Imkut uivenqellriit [?] tua-i tumaganek pilallruit. Assirluteng.",
        "translation": "Those round [?], they called them tannin. They were good."
    },
    "2": {
        "startTime": 42.465,
        "endTime": 46.835,
        "transcript": "Yeah, we're rolling, so thank you for your patience.",
        "translation": "Yeah, we're rolling, so thank you for your patience."
    },
    "3": {
        "startTime": 46.835,
        "endTime": 49.345,
        "transcript": "We can go ahead and start.",
        "translation": "We can go ahead and start."
    },
    "4": {
        "startTime": 53.065,
        "endTime": 61.7,
        "transcript": "Waniwa canek ak'a imumi niitelallerpenek qanquvet waniwa.",
        "translation": "Now, you should talk about what you used to hear way back then."
    },
    "5": {
        "startTime": 61.7,
        "endTime": 62.85,
        "transcript": "Ii-i.",
        "translation": "Okay."
    },
    "6": {
        "startTime": 63.45,
        "endTime": 69.29,
        "transcript": "Ellangellemni yuut waten ayuqellrunritut caarkaiturluteng.",
        "translation": "In my earliest memories, people weren't like this with nothing to do."
    },
    "7": {
        "startTime": 70.166,
        "endTime": 77.666,
        "transcript": "Yuilqumek tau͡gaam neqerluteng. Kass'artarnek nerrsiyaayuunateng.",
        "translation": "They only ate from the wilderness. They didn't eat too much Western food."
    },
    "8": {
        "startTime": 77.668,
        "endTime": 85.057,
        "transcript": "Maa-i tan'gaurluut uitqapigtelartut, atamek-llu tau͡gaam kaigaluteng.",
        "translation": "Now, boys are completely sedentary, and ask only of fathers."
    },
    "9": {
        "startTime": 85.069,
        "endTime": 94.981,
        "transcript": "Wii caliaricuitellruama iliirallrunritua atamnek, wangnek-llu pingnaqurallruama.",
        "translation": "Since I always had work, I never asked anything of my father, also because I tried to do things on my own."
    },
    "10": {
        "startTime": 94.998,
        "endTime": 101.542,
        "transcript": "Muragtaqlua pingayunek-ll' qimugterlua, ikamrarlua-llu.",
        "translation": "I'd go get wood and had three dogs, and a sled."
    },
    "11": {
        "startTime": 102.566,
        "endTime": 110.299,
        "transcript": "Imkunek-ll' arutulinek tua-i kuvyanek muragnek pugtaqutarluteng",
        "translation": "And with those drift nets that would deteriorate easily that had wooden floats"
    },
    "12": {
        "startTime": 110.305,
        "endTime": 113.928,
        "transcript": "Imkunek-llu imarkanek ak'allarnek.",
        "translation": "And those old bullets."
    },
    "13": {
        "startTime": 113.944,
        "endTime": 125.577,
        "transcript": "Tua-i qemingnaqu'urlua, kaillerkaqa tau͡gaam mukaaritlerkarput-llu umyuaqaqluku, kuingiitellerkaqa-llu.",
        "translation": "I'd always try to set the lead line, thinking of how we might go hungry, go without flour, and I'd have no cigarettes"
    },
    "14": {
        "startTime": 125.588,
        "endTime": 133.377,
        "transcript": "Inerqungraanga ayagaqlua, tau͡gaam qanrutaqanga niitelalllruunga.",
        "translation": "Though [s]he's admonish me, I'd go, but when [s]he spoke to me, I'd listen."
    },
    "15": {
        "startTime": 137.04,
        "endTime": 147.74,
        "transcript": "Ava-i cali qanellruuten caliangqerrumalarniluten, calillren-llu assikaqluku. Calivigpenek tamatumek cali qanqaa.",
        "translation": "You also just said that you always had job, and that you liked to work. Please talk about your workplace."
    },
    "16": {
        "startTime": 148.86,
        "endTime": 154.593,
        "transcript": "Cannery-mi calitullemni [?]turalallruunga.",
        "translation": "When I worked at a cannery, I'd always [?]."
    },
    "17": {
        "startTime": 154.601,
        "endTime": 158.012,
        "transcript": "Ilamni-ll' tua-i akikanrurrlua inarrlua.",
        "translation": "Then I'd owe my peers as I'd sleep at their places."
    },
    "18": {
        "startTime": 158.028,
        "endTime": 160.506,
        "transcript": "Calilqa assikluku.",
        "translation": "I liked to work."
    },
    "19": {
        "startTime": 160.511,
        "endTime": 163.367,
        "transcript": "Ciumek-llu taivkarrlainarlua.",
        "translation": "And they'd always let me come first."
    },
    "20": {
        "startTime": 163.385,
        "endTime": 167.329,
        "transcript": "Iliini tua-i kiaresngiatengyaaqnaurtua.",
        "translation": "Sometimes, I'd feel ashamed."
    },
    "21": {
        "startTime": 168.808,
        "endTime": 178.774,
        "transcript": "Makut-llu maa-i agayuviit yuirutut. Yuirutut. Makut TV-t yuirucetait.",
        "translation": "And now, there are no more people in these churches. There are no more people. These TV's are making them empty."
    },
    "22": {
        "startTime": 178.952,
        "endTime": 190.529,
        "transcript": "Maa-i makut, imkut-llu canek pilallrita, tamakut cali peggautek'larait",
        "translation": "These things, and whatever they call them, they stay up late at night for them"
    },
    "23": {
        "startTime": 191.909,
        "endTime": 204.454,
        "transcript": "Imumi ak'a TV-rtaitellruuq. Imkut tau͡gaam kenircuutellrat tem'irrnertulriit kiimeng piullruut, makunek cataunani.",
        "translation": "Long ago when there were no TVs. There were only those portable stoves that would make rumbling sounds, none of these."
    },
    "24": {
        "startTime": 206.606,
        "endTime": 215.172,
        "transcript": "Qaillun-mi wangkuta ayagyuani assirluta calisteńgullerkamteńun alerquryugngaceta?",
        "translation": "So what can you advise of us young people so that we will be good workers?"
    },
    "25": {
        "startTime": 215.384,
        "endTime": 226.861,
        "transcript": "Atam elluarrluni calilria Kass'at assikelaqiit, qailllukuarpek'nani caliani caliaqekii.",
        "translation": "You see, the Caucasians like those who work well, one who doesn't mess around but focuses on work.."
    },
    "26": {
        "startTime": 226.883,
        "endTime": 231.183,
        "transcript": "Tamaa-i tamakut assikelarait.",
        "translation": "Those are the ones they like."
    },
    "27": {
        "startTime": 232.062,
        "endTime": 240.017,
        "transcript": "Una-ggem tua-i caqtaarluni calilria ak'anun uitasciigatuq.",
        "translation": "One who is distracted when working cannot stay long."
    },
    "28": {
        "startTime": 240.023,
        "endTime": 247.968,
        "transcript": "Kanani-ll' co-op-ami calilria cali qaillukualria ak'anun uitasciiganani.",
        "translation": "And a worker who works at the co-op down there and messes around cannot stay long."
    },
    "29": {
        "startTime": 247.982,
        "endTime": 250.438,
        "transcript": "Au͡g'aqalaraat.",
        "translation": "They fires them."
    },
    "30": {
        "startTime": 250.755,
        "endTime": 253.699,
        "transcript": "Cali-q' tua-i cannery-lartuten?",
        "translation": "Do you still work at the cannery?"
    },
    "31": {
        "startTime": 253.716,
        "endTime": 255.594,
        "transcript": "Taqellruunga.",
        "translation": "I stopped."
    },
    "32": {
        "startTime": 255.61,
        "endTime": 259.621,
        "transcript": "Calissuutnek tau͡gaam waniw' akingyaurtellruunga.",
        "translation": "Instead, I started getting money from [?]."
    },
    "33": {
        "startTime": 259.623,
        "endTime": 272.356,
        "transcript": "Akinguqiit cali makunun-wa tua-i pistaini piqa'aqluki piuralaqiit, neqnek tuaten.",
        "translation": "The ones who receive money give them to who's responsible, including food."
    },
    "34": {
        "startTime": 277.434,
        "endTime": 288.04,
        "transcript": "Tayima qanruyutnek niitelallruuten ciuliarpenek. Tamakunek cali qanqaa.",
        "translation": "You've probaby heard of traditional wisdom from your elders. Please talk about those."
    },
    "35": {
        "startTime": 288.059,
        "endTime": 305.159,
        "transcript": "Wiinga unisteḿa qanruquralallruanga, \"Tua-i qessavkenii pilaasqellua. Atam-gguq qessanqu͡rukuma, unkut unani nallunritaten neqet kuimalriit,",
        "translation": "My late father always said to me, :\"Never be lazy. If I'm lazy, you know of the fish down there"
    },
    "36": {
        "startTime": 305.167,
        "endTime": 310.8,
        "transcript": "\"Tangaangramki qemineq-llu nallukumku kailarniartua.\"",
        "translation": "\"Even if I see them and don't know how to set a lead line, I will be hungry.\""
    },
    "37": {
        "startTime": 310.804,
        "endTime": 315.987,
        "transcript": "Maa-i tamaaken ayaglua kaiksaitua.",
        "translation": "I've never been hungry since then."
    },
    "38": {
        "startTime": 316.014,
        "endTime": 319.231,
        "transcript": "Kaiksaitua tua-i.",
        "translation": "I've never been hungry."
    },
    "39": {
        "startTime": 319.254,
        "endTime": 329.376,
        "transcript": "Elpet-llu tua-i assirluten tua-i calikuvet au͡g'arngaitaatgetn. Assirluten.",
        "translation": "And if you work well, they won't fire you. You'll be good."
    },
    "40": {
        "startTime": 329.428,
        "endTime": 339.177,
        "transcript": "Wii waniw' assirlua calingnaqurallruama calinermek taqua.",
        "translation": "Since I tried to work well, I stopped working."
    },
    "41": {
        "startTime": 340.194,
        "endTime": 345.12,
        "transcript": "Angyakun-ll' agyuunii, tengssuuterrlainarkunt tau͡gaam.",
        "translation": "And I wouldn't go by boat, but always with a plane."
    },
    "42": {
        "startTime": 346.896,
        "endTime": 352.736,
        "transcript": "Ciuqliurrlua ikani misvillermi, ciumek-llu qayagaurtu'rlua.",
        "translation": "I became the first in the airport across there, and they'd always call me first."
    },
    "43": {
        "startTime": 352.922,
        "endTime": 359.749,
        "transcript": "Taiqataamta-ll' tua-i ciumek qayagaurlua. Yuuqataamta-ll' cali qayagaurlua.",
        "translation": "When we were going to come, they'd call me first. And when we were going to disembark, they'd also call me."
    },
    "44": {
        "startTime": 359.764,
        "endTime": 363.035,
        "transcript": "Taumek tang kiaresngiatenglalrianga.",
        "translation": "You see, that's why I'd be ashamed."
    },
    "45": {
        "startTime": 363.047,
        "endTime": 365.788,
        "transcript": "Ciuqliurrlainarlua.",
        "translation": "I was always first."
    },
    "46": {
        "startTime": 368.224,
        "endTime": 372.866,
        "transcript": "Atam elpet-llu qaillukuarpek'nak. Qanrutqataramken.",
        "translation": "Look, you shouldn't mess around either. I'm going to tell you."
    },
    "47": {
        "startTime": 372.877,
        "endTime": 382.137,
        "transcript": "Tua-i calisteńguyaaquten. Qaillukuarpek'nak caliurquvet au͡g'arngaitaatgen.",
        "translation": "You are a worker. If you work without messing around, they won't fire you."
    },
    "48": {
        "startTime": 383.483,
        "endTime": 391.829,
        "transcript": "Waniw' cali qanqautnaluten, wii tang waten ellilrianga au͡g'arpailgatnga.",
        "translation": "I also wanted to tell you that I've reached this age before I've been fired."
    },
    "49": {
        "startTime": 392.588,
        "endTime": 403.995,
        "transcript": "Una-ll' iruka waniw' waken ayagluni [?]umayaaquq. Iruicaaqua. Una-ll' plastic-aaruluni malrugnek-ll' ussukcarluni.",
        "translation": "And my leg here is [?] starting from here. I have injured legs. And this one is plastic with two screws."
    },
    "50": {
        "startTime": 406.28,
        "endTime": 413.712,
        "transcript": "Qaill' una mukaaq imumi akingqelallrua cat akiitelallratni?",
        "translation": "How much did flour cost back when things were inexpensive?"
    },
    "51": {
        "startTime": 413.72,
        "endTime": 415.609,
        "transcript": "Akiitellruut pingayutun.",
        "translation": "They were inexpensive, $3."
    },
    "52": {
        "startTime": 415.645,
        "endTime": 418.115,
        "transcript": "Qaill' uqamait?",
        "translation": "How much did they weigh?"
    },
    "53": {
        "startTime": 418.123,
        "endTime": 423.296,
        "transcript": "Imna 50 lb-aq akiitqapiggluni tua-i pingayutun.",
        "translation": "A 50 lb. bag was very inexpensive, $3."
    },
    "54": {
        "startTime": 424.158,
        "endTime": 426.714,
        "transcript": "Saayut-llu malrugtun.",
        "translation": "And tea was $2."
    },
    "55": {
        "startTime": 426.723,
        "endTime": 428.859,
        "transcript": "Akiinani.",
        "translation": "It was inexpensive."
    },
    "56": {
        "startTime": 428.873,
        "endTime": 436.256,
        "transcript": "Maa-i-w' caperrnarilriit. Caperrnariut.",
        "translation": "Now, they've become difficult [to get]. They've become difficult."
    },
    "57": {
        "startTime": 436.501,
        "endTime": 442.871,
        "transcript": "Imna allragni ayakautellrat nataqumangaituq.",
        "translation": "What they took last year won't be found."
    },
    "58": {
        "startTime": 442.882,
        "endTime": 446.228,
        "transcript": "Massiinallret qanrutekngaitaqa.",
        "translation": "I won't speak of the old boat motors."
    },
    "59": {
        "startTime": 450.428,
        "endTime": 453.428,
        "transcript": "Kaassaq-mi qaill' akingqelallrua?",
        "translation": "How expensive was gas?"
    },
    "60": {
        "startTime": 454.141,
        "endTime": 455.758,
        "transcript": "Talliman...",
        "translation": "Five dollars..."
    },
    "61": {
        "startTime": 459.112,
        "endTime": 466.581,
        "transcript": "Imna drum-aq $25. Akiitqapiggluni maa-i.",
        "translation": "A drum was $25. It's very inexpensive [compared to] now."
    },
    "62": {
        "startTime": 466.712,
        "endTime": 469.489,
        "transcript": "Maa-i-w' caperrnarilriit.",
        "translation": "Now, they're difficult [to get]."
    },
    "63": {
        "startTime": 469.499,
        "endTime": 476.487,
        "transcript": "Uqulkuut-llu malrugtun akiluteng. Motor oil, $2.",
        "translation": "And [motor] oil was $2. Motor oil, $2."
    },
    "64": {
        "startTime": 478.059,
        "endTime": 482.961,
        "transcript": "Akiillit-tuq maa-i aklut. Akiillit-tuq.",
        "translation": "I wish things were inexpensive now. I wish they were inexpensive."
    },
    "65": {
        "startTime": 482.963,
        "endTime": 489.185,
        "transcript": "Ii-i, maa-i-w' caperrnarilriit, aklut-ll' akituluteng. Akituriluteng.",
        "translation": "Yes, they're not difficult [to get], and things are expensive. They've gotten expensive."
    },
    "66": {
        "startTime": 491.549,
        "endTime": 499.746,
        "transcript": "Camek-wa tua-i nangnermek qanqeryukuvet waniwa nangnermek qanqerluten.",
        "translation": "If there's a final thing you'd like to say, say the last thing now."
    },
    "67": {
        "startTime": 500.586,
        "endTime": 504.463,
        "transcript": "Pray-aqaqerlii. Pisqumaarpenga-qaa?",
        "translation": "Let me pray. Do you want me to?"
    },
    "68": {
        "startTime": 504.481,
        "endTime": 505.691,
        "transcript": "Yaa, piyukuvet.",
        "translation": "Yes, if you want to."
    },
    "69": {
        "startTime": 505.697,
        "endTime": 506.783,
        "transcript": "Ii-i.",
        "translation": "Okay."
    },
    "70": {
        "startTime": 507.5,
        "endTime": 514.759,
        "transcript": "Oh, Lord Jesus, God. Agayun atavut Qilagmetellriami atren kenciknarili.",
        "translation": "Oh, Lord Jesus, God. God, our father, who art in Heaven, hallowed be thy name."
    },
    "71": {
        "startTime": 514.769,
        "endTime": 519.843,
        "transcript": "Angayuqaviin tekilli. Pisqucin nunam qaingani piuli Qilagmitun.",
        "translation": "May your kingdom come. May your will be done on earth as it is in Heaven."
    },
    "72": {
        "startTime": 519.856,
        "endTime": 527.09,
        "transcript": "Neqkamteńek ernerpak cikirkut. Assiilngumteńek-ll' au͡g'ariskut wangkutnun assiilngilriit au͡g'aritelaucimcetun.",
        "translation": "Give us this day our daily bread. And forgive us our trespasses as we forgive those who trespass against us."
    },
    "73": {
        "startTime": 527.099,
        "endTime": 532.247,
        "transcript": "Picetaarutmun pivkaqsaunata tau͡gaam assiitellriamek aviuskut.",
        "translation": "Lead us not into temptation but deliver us from evil."
    },
    "74": {
        "startTime": 532.266,
        "endTime": 540.809,
        "transcript": "Angayuqaavik, piniq-llu, ucurnarquciq-llu elpet pikngavki nangyuilngurmek, amen. Quyana Jesus, amen.",
        "translation": "For yours is the kingdom, and the power, and the glory forever and ever, amen. Thank you Jesus, amen."
    },
    "75": {
        "startTime": 541.624,
        "endTime": 543.069,
        "transcript": "Quyana.",
        "translation": "Thank you."
    },
    "76": {
        "startTime": 545.068,
        "endTime": 549.006,
        "transcript": "Tua-i elluarrluten calingnaqu'urqina. (Yaa.)",
        "translation": "Now, try to always work well. (Okay.)"
    },
    "77": {
        "startTime": 549.02,
        "endTime": 554.551,
        "transcript": "Maa-i tang elluarrluteng calinrilnguut au͡g'alaqait.",
        "translation": "Now, you see, they fire those who don't work well."
    },
    "78": {
        "startTime": 555.993,
        "endTime": 560.919,
        "transcript": "Elluarrluni tau͡gaam caliuralria Kass'am assikelaraa.́",
        "translation": "Caucasians like one who works well."
    },
    "79": {
        "startTime": 561.672,
        "endTime": 566.573,
        "transcript": "Wii waniw' au͡g'arpailgatnga [?].",
        "translation": "Now, before they fired me, [?]."
    }
};